(function MytripsDocuments($, Adzuki)
{
	"use strict";

	$(document).ready(function documentReady()
	{
		Adzuki.onload('MyTrips/tripDocuments', function onload()
		{
			var count = 0;

			$('.EmptyFind').each(function findEmptyTab() {
				var $txt = $(this).text().trim().length;
				var $dataTarget = $(this).attr('id');
				var $tabToHide = $('#descriptionTab a[href="#' + $dataTarget + '"]').closest('li');

				if ($txt < 1) {
					$tabToHide.removeClass('active');
					$(this).removeClass('fade in active');
					$tabToHide.hide();
				} else {
					if (count < 1) {
						$tabToHide.addClass('active');
						$(this).addClass('fade in active');
					}

					count++;
				}
			});
		});
	});
}(jQuery, window.Adzuki || {}));
